import {
    TimelineConnector,
    TimelineContent,
    TimelineItemElement,
    TimelineOppositeContent,
} from "../TimelineItem.styles";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { GameStateChangedTitle, TimelineEnd } from "../GameTimeline.styles";
import React from "react";

export function MatchEndedEvent() {
    return (
        <TimelineItemElement>
            <TimelineOppositeContent />
            <TimelineSeparator>
                <GameStateChangedTitle>Abpfiff</GameStateChangedTitle>
                <TimelineEnd />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent />
        </TimelineItemElement>
    );
}
